import { cn } from '@sohanemon/utils';
import { Iconify, Portal } from '@sohanemon/utils/components';
import * as m from 'motion/react-m';
import type * as React from 'react';
import { MotionProvider } from '../motion';

type TopLoaderProps = React.ComponentProps<typeof m.div>;

export function TopLoader({ className, ...props }: TopLoaderProps) {
	return (
		<Portal>
			<MotionProvider>
				<m.div
					id="top-loader"
					initial={{
						y: -80,
						opacity: 0,
						scale: 0.85,
					}}
					animate={{
						y: 18,
						opacity: 1,
						scale: 1,
					}}
					exit={{
						y: -80,
						opacity: 0,
						scale: 0.85,
					}}
					transition={{
						type: 'spring',
						stiffness: 250,
						damping: 18,
					}}
					aria-hidden="true"
					className={cn(
						'pointer-events-none fixed top-0 left-0 z-99999999 h-96 w-full select-none',
						className,
					)}
					{...props}
				>
					<div className="absolute top-0 grid size-full -translate-y-1/2 place-content-center rounded-[50%] bg-border/50 blur-[70px]" />
					<Iconify
						className="mx-auto mt-2 size-14 animate-spin rounded-full bg-background/50 p-2.5"
						icon="lucide:loader-2"
					/>
				</m.div>
			</MotionProvider>
		</Portal>
	);
}
